module.exports = __webpack_public_path__ + "img/b.cb7b5c28.jpg";